var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightningBoltFill = function SvgLightningBoltFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.5 0C7.388 0 0 7.39 0 16.5 0 25.615 7.388 33 16.5 33S33 25.615 33 16.5C33 7.39 25.612 0 16.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2F500",
    d: "M18 5 9 19.375h6V28l9-14.375h-6z"
  })));
};
export default SvgLightningBoltFill;